import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

export interface DispatchWebhook {
  id: number;
  url: string;
  type: 'slack' | 'teams' | 'discord' | 'generic';
  label: string | null;
  orgId: number | null;
  departmentId: number | null;
  userId: number | null;
}

export const WEBHOOKS_QUERY_KEY = ['clip-dispatch', 'webhooks'] as const;

export const useDispatchWebhooksQuery = () =>
  useQuery({
    queryKey: WEBHOOKS_QUERY_KEY,
    queryFn: async () => {
      const res = await get<DispatchWebhook[]>('/v1.0/clip-dispatch/webhooks');
      return res.data;
    },
  });
